import { SVGProps } from 'react'
import { JSX } from 'react/jsx-runtime'

export function CheckIcon(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={13} height={10} fill='none' {...props}>
      <path
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
        strokeWidth={2}
        d='M1 5.649 4.243 9 11.5 1.5'
      />
    </svg>
  )
}
